import React from "react";
import SignatureTreeStore from "../../stores/SignatureTreeStore";
import "../../../css/ReportingWelfare.css";
import PropTypes from "prop-types";
import { SearchUrl, SuicideUrl, SignatureUrl } from "../navigation/RedFlagUrls";
import { Icon } from "@familyzone/component-library";
import { signatureRedFlagsByRegion } from "./UserDashboard/RedFlagsCardHelper";

export default class RedFlags extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      userRiskSelectorScore: {},
    };
  }

  findColorClassName = (user, indicatorKey) => {
    let score = this.props.userRiskSelectorScore[user][indicatorKey];
    if (score > 5) {
      return "riskStudentIndicator-high";
    } else if (score > 2) {
      return "riskStudentIndicator-medium";
    }
    return "riskStudentIndicator-low";
  };

  renderRiskyBusiness = (row) => {
    let ret = [];
    let normals = row["normals"];
    let keywords = SignatureTreeStore.getKeywords();
    let signatures = signatureRedFlagsByRegion();
    for (let indicatorKey in normals) {
      for (let signature of signatures) {
        if (indicatorKey === signature.id) {
          if (row[indicatorKey] > 0) {
            ret.push(
              <div
                key={indicatorKey}
                onClick={() => this.handle_openSignatureRedFlag(row["name"], signature.signature_id)}
                className={
                  "indicatorSelectable " + this.props.indicatorClassname + " " + this.findColorClassName(row["name"], indicatorKey)
                }
              >
                <div className={"riskStudentIndicatorText newUiRiskIndicatorButton"}>
                  <Icon boxSize="12px" icon="fa fa-globe" />
                  {signature.name}
                </div>
              </div>
            );
          }
        }
      }

      if (indicatorKey === "suicidal_search_term") {
        if (row[indicatorKey] > 0) {
          ret.push(
            <div
              key={indicatorKey}
              onClick={() => this.handle_OpenSuicideRedFlag(row["name"])}
              className={"indicatorSelectable  " + this.props.indicatorClassname + " " + this.findColorClassName(row["name"], indicatorKey)}
            >
              <div className={"riskStudentIndicatorText newUiRiskIndicatorButton"}>Suicidal Search</div>
            </div>
          );
        }
      }
      if (indicatorKey === "devices") {
        if (row[indicatorKey] && row[indicatorKey].length > 5) {
          let colorClassname = this.findColorClassName(row["name"], indicatorKey);
          ret.push(
            <div key={indicatorKey} className={"smallRiskStudentIndicator " + this.props.indicatorClassname + " " + colorClassname}>
              <div className={"riskStudentIndicatorText newUiRiskIndicatorButton"}>
                <Icon boxSize="12px" icon="fa fa-cog" />
                {row[indicatorKey].length} Devices
              </div>
            </div>
          );
        }
      }
      for (let keyword of keywords) {
        if (indicatorKey === keyword.id) {
          if (row["search_indicators"][indicatorKey] > 0) {
            let colorClassname = this.findColorClassName(row["name"], indicatorKey);
            ret.push(
              <div
                key={indicatorKey}
                onClick={() => this.handle_OpenSearchRedFlag(row["name"], keyword.name)}
                className={"indicatorSelectable " + this.props.indicatorClassname + " " + colorClassname}
              >
                <div className={"riskStudentIndicatorText newUiRiskIndicatorButton"}>
                  <Icon boxSize="12px" icon="fa fa-search" />
                  {keyword.name}
                </div>
              </div>
            );
          }
        }
      }
    }
    return ret;
  };

  handle_openSignatureRedFlag(userId, signatureId) {
    this.context.router.push(SignatureUrl(userId, signatureId));
  }
  handle_OpenSuicideRedFlag(userId) {
    this.context.router.push(SuicideUrl(userId));
  }

  handle_OpenSearchRedFlag(userId, searchId) {
    this.context.router.push(SearchUrl(userId, searchId));
  }

  render() {
    return <div className={this.props.divClassName}>{this.renderRiskyBusiness(this.props.data)}</div>;
  }
}

RedFlags.contextTypes = {
  router: PropTypes.object.isRequired,
};
